let info = {
    name: "Wahyu Saragih",
    logo_name: "Wahyu S",
    logo_icon: require("./src/assets/logo.png"),
    // flat_picture: require("./src/assets/me.png"),
    flat_picture: require("./src/assets/images/maestro.png"),
    config: {
        use_cookies: true,
        navbar: {
            blur: false
        }
    },
    description: "hey there, I'm Wahyu Saragih. I’m a UI/UX designer, front-end web developer, product designer and technician from Bandung. I’m always curious to learn more when it comes to new technologies. Interested in working on ambitious projects with positive people.",
    links: {
        linkedin: "https://www.linkedin.com/in/wahyu-h-saragih-3b4543139/",
        github: "https://github.com/wahyusaragih",
        resume: "",
    },
    education: [{
        name: "KFS University",
        place: "Kafr Elsheikh",
        date: "sep, 2018 - present",
        degree: "bachelor in software engineering",
        gpa: "3.1/4.0",
        description: "",
        skills: [
            "Software Engineering",
            "web programming",
            "UI/UX design",
            "Front-end developing",
        ]
    }, ],
    experience: [{
            name: "ITI",
            place: "Kafr elSheikh, Egypt",
            date: "1,sep, 2021 - 28,sep, 2021",
            position: "VueJS web developer",
            description: "",
            skills: ["HTML5", "CSS3", "Bootstrap", "JQuery", "Json", "JavaSript", "TypeSript", "es6", "VueJS"]
        },
        {
            name: "Udacity",
            place: "Egypt",
            date: "Jun 2021 - Jan 2022",
            position: "React Web Developer",
            description: "",
            skills: ["Javascript", "Typescript", "ReactJS", "React-Redux", "webpack", "NLP"]
        },
        {
            name: "Freelancer",
            place: "Egypt",
            date: "jun, 2021 - sep, 2021",
            position: "Junior UI/UX Designer",
            description: "creating apps and web UI, Creating Interactive prototypes, Low fidelity and UX researches",
            skills: ["figma", "Adobe XD", "Photoshop", "Illustrator"]
        },
        {
            name: "Technopolitan",
            place: "Cairo, Egypt",
            date: "Jan 2022 - Present",
            position: "Mid-Level UI/UX Designer",
            description: "part of team include project managers and developers to create technically feasible design, creating 95% of CRM of the company ,creating user experience and interface using adobe XD for best user solution ,finishing 80% of tasks before the target ",
            skills: ["figma", "Adobe XD"]
        },
    ],
    skills: [{
            title: "UI/UX Design",
            info: ["Illustrator", "XD", "Photoshop"],
            icon: "fa fa-pencil-square-o"
        },
        {
            title: "Web Technologies",
            info: ["Vue", "HTML", "CSS", "Javascript"],
            icon: "fas fa-code"
        },
        {
            title: "Product Design",
            info: ["Fusion 360", "Cura"],
            icon: "fas fa-cube"
        },
        {
            title: "Technician",
            info: ["Weather Station Installation"],
            icon: "fas fa-helmet-safety"
        },
    ],
    uiux_design: [{
            title: "Digital Marketing - UI/UX Design",
            technologies: ["Illustrator", "XD", "Photoshop", ],
            date: "Oct, 2019",
            name: "Digital Marketing",
            category: "UI/UX Design",
            description: "Digital platform used by marketing to support aggressive marketing and business development strategy programs.",
            pictures: [{
                    img: require("./src/assets/designs/digital marketing/0. Login.jpg"),
                    title: "Login"
                },
                {
                    img: require("./src/assets/designs/digital marketing/2. Project_2.jpg"),
                    title: "Project"
                },
                {
                    img: require("./src/assets/designs/digital marketing/6. Information_2.jpg"),
                    title: "Newsletter"
                },
                {
                    img: require("./src/assets/designs/digital marketing/7. GMF Service_2.jpg"),
                    title: "GMF Services"
                },
            ],
            github: "",
            visit: "",
        },
        {
            title: "MLOSA - UI/UX Design",
            technologies: ["Illustrator", "XD", "Photoshop", ],
            date: "Nov, 2019",
            name: "MLOSA - Maintenance Line Operations Safety Audit",
            category: "UI/UX Design",
            description: "Facilitate the process of observing and making reports in real time, so they can quickly analyze all existing problems.",
            pictures: [{
                    img: require("./src/assets/designs/mlosa/0. mlogin.jpg"),
                    title: "Login"
                },
                {
                    img: require("./src/assets/designs/mlosa/Admin/1. home.jpg"),
                    title: "Home"
                },
                {
                    img: require("./src/assets/designs/mlosa/Admin/3. global plan_1.jpg"),
                    title: "Global MLOSA Plan"
                },
                {
                    img: require("./src/assets/designs/mlosa/Admin/4. observation_4.jpg"),
                    title: "Observation Form"
                },
                {
                    img: require("./src/assets/designs/mlosa/Mock up MLOSA mobile/2. login.jpg"),
                    title: "Mobile Login"
                },
                {
                    img: require("./src/assets/designs/mlosa/Mock up MLOSA mobile/3. home.jpg"),
                    title: "Mobile Home"
                },
            ],
            github: "",
            visit: "",
        },
        {
            title: "RMS For CBO-TC - UI/UX Design",
            technologies: ["Illustrator", "XD", "Photoshop", ],
            date: "Dec, 2019",
            name: "RMS For TC (Component Service Unit)",
            category: "UI/UX Design",
            description: "Controlling changes in item values related to COGS calculations and being able to perform price simulations based on COGS data",
            pictures: [{
                    img: require("./src/assets/designs/rms for cbo/0. login.jpg"),
                    title: "Login"
                },
                {
                    img: require("./src/assets/designs/rms for cbo/Mockup RMS for TC/1. COGS TCA, TCE, TCW_1_edit.jpg"),
                    title: "COGS"
                },
                {
                    img: require("./src/assets/designs/rms for cbo/Mockup RMS for TC/8. Pricing TCA, TCE, TCW.jpg"),
                    title: "Pricing Simulation"
                },
            ],
            github: "",
            visit: "",
        },
        {
            title: "RMS For CBO-TG - UI/UX Design",
            technologies: ["Illustrator", "XD", "Photoshop", ],
            date: "Feb, 2020",
            name: "RMS For TG (Logistic, Bonded & Material Services Unit)",
            category: "UI/UX Design",
            description: "Controlling target logistics, cost approval, price list, shipment status and simulating prices that will be given to customers",
            pictures: [{
                    img: require("./src/assets/designs/rms for cbo/0. login.jpg"),
                    title: "Login"
                },
                {
                    img: require("./src/assets/designs/rms for cbo/Mockup RMS for TG/2. Target Logistic_2.jpg"),
                    title: "Target Logistic"
                },
                {
                    img: require("./src/assets/designs/rms for cbo/Mockup RMS for TG/3. Cost Approval_0.jpg"),
                    title: "Cost Approval"
                },
                {
                    img: require("./src/assets/designs/rms for cbo/Mockup RMS for TG/5. Price List_2.jpg"),
                    title: "Price List"
                },
                {
                    img: require("./src/assets/designs/rms for cbo/Mockup RMS for TG/4. Simulation.jpg"),
                    title: "Price Simulation"
                },
            ],
            github: "",
            visit: "",
        },
        {
            title: "GMF Mentoring Program - UI/UX Design",
            technologies: ["Illustrator", "XD", "Photoshop", ],
            date: "Mar, 2020",
            name: "GMF Mentoring Program",
            category: "UI/UX Design",
            description: "MEL Digital application that is able to create MIP reports as well as storage media and distribution of e-learning materials as well as mentee data storage.",
            pictures: [{
                    img: require("./src/assets/designs/mentoring program/0. login.jpg"),
                    title: "Login"
                },
                {
                    img: require("./src/assets/designs/mentoring program/7. Dashboard_1.jpg"),
                    title: "Dashboard"
                },
                {
                    img: require("./src/assets/designs/mentoring program/4. Program_2 - Core Team.jpg"),
                    title: "Program"
                },
                {
                    img: require("./src/assets/designs/mentoring program/5, Quiz_7 -Mentee.jpg"),
                    title: "Quiz"
                },
                {
                    img: require("./src/assets/designs/mentoring program/6. Learning Material_1.jpg"),
                    title: "Learning Material"
                },
            ],
            github: "",
            visit: "",
        },
        {
            title: "RMS Pricing Strategy - UI/UX Design",
            technologies: ["Illustrator", "XD", "Photoshop", ],
            date: "Apr, 2020",
            name: "RMS Pricing Strategy",
            category: "UI/UX Design",
            description: "Module development of the G-SMART application which has control and tracking functions on Progress Billing, Manhours rate cost and its utilization in each GMF business line, COPA data, and customer receivables data.",
            pictures: [{
                    img: require("./src/assets/designs/rms pricing strategy/0. login.jpg"),
                    title: "Login"
                },
                {
                    img: require("./src/assets/designs/rms pricing strategy/1.0 AR_Dashboard.jpg"),
                    title: "AR Dashboard"
                },
                {
                    img: require("./src/assets/designs/rms pricing strategy/1.9 Bad Debt - Report.jpg"),
                    title: "Bad Debt"
                },
                {
                    img: require("./src/assets/designs/rms pricing strategy/2.0 Mhrs Rate Summary.jpg"),
                    title: "Manhours Rate"
                },
                {
                    img: require("./src/assets/designs/rms pricing strategy/4.3 PnL Simulation.jpg"),
                    title: "PnL Simulation"
                },
                {
                    img: require("./src/assets/designs/rms pricing strategy/5. CoPA.jpg"),
                    title: "COPA"
                },
            ],
            github: "",
            visit: "",
        },
    ],
    dev: [{
            name: "Brajakara Teknologi Media",
            technologies: ["vue", "css"],
            description: "A company that provides weather system installation includes data logger, sensors and web app based on client needs. Vue site to introduce business services. ",
            github: "",
            visit: "http://www.blitztechnology.co.id/",
            date: "Mar 2020 - present",
            category: "Website",
            pictures: [{
                    img: require("./src/assets/dev/btm/1.jpg")
                },
                {
                    img: require("./src/assets/dev/btm/2.jpg")
                },
                {
                    img: require("./src/assets/dev/btm/3.jpg")
                },
                {
                    img: require("./src/assets/dev/btm/4.jpg")
                },
                {
                    img: require("./src/assets/dev/btm/5.jpg")
                },
                {
                    img: require("./src/assets/dev/btm/6.jpg")
                },
            ],
        },
        {
            name: "B-Weather",
            technologies: ["vue", "django"],
            description: "Real-time weather data monitoring and the data can be downloaded to facilitate reporting written in Vue and Django-MySQL integration.",
            github: "",
            visit: "https://www.bbwssumateraviii.co.id/",
            date: "Oct 2021 - present",
            category: "Web App",
            pictures: [{
                    img: require("./src/assets/dev/bweather/1.jpg")
                },
                {
                    img: require("./src/assets/dev/bweather/2.jpg")
                },
                {
                    img: require("./src/assets/dev/bweather/3.jpg")
                },
                {
                    img: require("./src/assets/dev/bweather/4.jpg")
                },
            ],
        },
        {
            name: "This Website",
            technologies: ["vue", "css"],
            description: "A simple portofolio website written in Vue.",
            github: "",
            visit: "https://wahyusaragih.github.io/",
            date: "Aug 2022 - present",
            category: "Web App",
            pictures: [{
                    img: require("./src/assets/dev/thiswebsite/1.jpg")
                },
                {
                    img: require("./src/assets/dev/thiswebsite/2.jpg")
                },
            ],
        },

    ],
    product_design: [{
            title: "Mini Tipping Bucket",
            model: "./models/Mini TB.stl",
            technologies: ["Fusion 360"],
            date: "Jul, 2021",
            name: "Mini Tipping bucket",

        },
        {
            title: "Shrine",
            model: "./models/Honden.stl",
            technologies: ["Fusion 360"],
            date: "Oct, 2020",
        },
    ],
    technician: [{
            title: "JKT-BDG High Speed Rail - Engineer",
            technologies: ["Geotechnic"],
            date: "Feb 2017 - Sep 2018",
            name: "Geotechnical Engineer",
            category: "Geotechnical",
            description: "Supervise every stage of drilling process, geotechnical investigation",
            pictures: [{
                    img: require("./src/assets/technician/HSR/2.jpg"),
                    title: "Drilling Station"
                },
                {
                    img: require("./src/assets/technician/HSR/1.jpg"),
                    title: "Drilling machine mobilization"
                },
                {
                    img: require("./src/assets/technician/HSR/3.jpg"),
                    title: "Core sampling"
                },
                {
                    img: require("./src/assets/technician/HSR/5.jpg"),
                    title: "Corebox"
                },
                {
                    img: require("./src/assets/technician/HSR/4.jpg"),
                    title: "Drilling activity"
                },
            ],
            github: "",
            visit: "",
        },
        {
            title: "ARR Installation - Technician",
            technologies: ["Electronic"],
            date: "Oct 2018 - present",
            name: "Automatic Rainfall Recorder Station",
            category: "Technician",
            description: "A set of equipment used to calculate the amount of rainfall in a certain time unit automatically by storing data into SD memory and sending data to the server with the help of a battery as its power source.",
            pictures: [{
                    img: require("./src/assets/technician/ARR/5.jpg"),
                    title: "ARR Station"
                },
                {
                    img: require("./src/assets/technician/ARR/3.jpg"),
                    title: "Fencing installation"
                },
                {
                    img: require("./src/assets/technician/ARR/4.jpg"),
                    title: "Fencing installation"
                },
                {
                    img: require("./src/assets/technician/ARR/1.jpg"),
                    title: "Set up data logger"
                },
                {
                    img: require("./src/assets/technician/ARR/2.jpg"),
                    title: "Set up data logger"
                },
                {
                    img: require("./src/assets/technician/ARR/6.jpg"),
                    title: "ARR Sensor"
                },
            ],
            github: "",
            visit: "",
        },
        {
            title: "AWLR Installation - Technician",
            technologies: ["Electronic"],
            date: "Oct 2018 - present",
            name: "Automatic Water Level Recorder Station",
            category: "Technician",
            description: "A set of equipment used to measure the water level automatically by storing data into SD memory and sending data to the server with the help of a battery as its power source.",
            pictures: [{
                    img: require("./src/assets/technician/AWLR/5.jpg"),
                    title: "AWLR Station"
                },
                {
                    img: require("./src/assets/technician/AWLR/1.jpg"),
                    title: "Fencing installation"
                },
                {
                    img: require("./src/assets/technician/AWLR/2.jpg"),
                    title: "Sensor installation"
                },
                {
                    img: require("./src/assets/technician/AWLR/3.jpg"),
                    title: "Set up data logger"
                },
                {
                    img: require("./src/assets/technician/AWLR/4.jpg"),
                    title: "Set up data logger inside enclosure"
                },

            ],
            github: "",
            visit: "",
        },
        {
            title: "AWS Installation - Technician",
            technologies: ["Electronic"],
            date: "Sep 2019 - present",
            name: "Automatic Weather Station",
            category: "Technician",
            description: "An integrated equipment or system designed for automatic weather data collection and processing to make observations easier. The sensors used include sensors for wind direction and speed, temperature, humidity, pressure, solar radiation, evaporation, rainfall.",
            pictures: [{
                    img: require("./src/assets/technician/AWS/5.jpg"),
                    title: "AWS Station"
                },
                {
                    img: require("./src/assets/technician/AWS/2.jpg"),
                    title: "Tower installation"
                },
                {
                    img: require("./src/assets/technician/AWS/3.jpg"),
                    title: "Tower installation"
                },
                {
                    img: require("./src/assets/technician/AWS/1.jpg"),
                    title: "Sensor installation"
                },
                {
                    img: require("./src/assets/technician/AWS/4.jpg"),
                    title: "Set up data logger"
                },
            ],
            github: "",
            visit: "",
        },
    ],
};

export default info;